import BaseCommand from "@/models/api/commands/BaseCommand";

export class CopyAgentIdToAllBookingItemCommand extends BaseCommand {
  CommandName = "CopyAgentIdToAllBookingItem";
  Command: {
    AgentId: string;
  };
  constructor(sessionId: string, operationId: string, agentId: string) {
    super(sessionId, operationId);
    this.Command = { AgentId: agentId };
  }
}
